
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.563.43h4.125v8.556l-4.125-2.334V.43z","fill":"#007185"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.063 5.438a.998.998 0 00-.665.252l-8.625 7.667a1 1 0 00-.335.748v8.384a.5.5 0 00.5.5h5.874a.5.5 0 00.5-.5v-4.722a1 1 0 011-1h1.75V5.437zM14.063 5.438c.237 0 .474.084.664.252l8.625 7.667a1 1 0 01.335.748v8.384a.5.5 0 01-.5.5h-5.874a.5.5 0 01-.5-.5v-4.722a1 1 0 00-1-1h-1.75V5.437z","fill":"#007185"}}),_c('path',{attrs:{"d":"M1 12.878L13.396 1.806a1 1 0 011.332 0l12.397 11.072","stroke":"#007185","stroke-width":"1.8"}})])
          )
        }
      }
    